import { HTTPClient } from "./Client";
import Cookies from "js-cookie";
import Criptografia from "./Criptografia";
import { jwtDecode } from "jwt-decode";

const UsuarioApi = {
  async loginAsync(email, senha) {
    const usuario = {
      Email: email,
      Senha: senha,
    };

    try {
      const response = await HTTPClient.post(`/Autenticar/login`, usuario);
      if (response && response.data) {
        const token = response.data;

        Cookies.set("token", JSON.stringify(token), {
          expires: 8 / 24,
          path: "/",
          sameSite: "Lax",
          domain: process.env.REACT_APP_DOMINIO,
          secure: process.env.REACT_APP_ENVIRONMENT,
        });

        const dados = jwtDecode(token.jwt);
        return {
          primeiroLogin: token.primeiroLogin,          // vem do objeto, fora do jwt ✔
          grupodeUsuario: dados.GrupoDeUsuarioId,       // vem do jwt, com G maiúsculo ✔
        };

      } else {
        console.error("Estrutura de resposta inesperada:", response);
        return null;
      }
    } catch (error) {
      throw error;
    }
  },

  recuperarSenhaAsync: async (email) => {
    try {
      const response = await HTTPClient.post(
        "/RecuperacaoDeSenha/SolicitarRecuperacaoDeSenha",
        { email }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro durante a chamada da API de recuperação de senha:",
        error
      );
      throw error;
    }
  },

  redefinirSenhaAsync: async (token, novaSenha) => {
    try {
      const response = await HTTPClient.post(
        "/RecuperacaoDeSenha/RedefinirSenha",
        { token, novaSenha }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro durante a chamada da API de redefinição de senha:",
        error
      );
      throw error;
    }
  },

  redefinirSenhaUsuarioPrimeiroLoginAsync: async (senha, token) => {
    try {
      const response = await HTTPClient.put(
        "/Usuario/RedefinirSenhaUsuario",
        { senha }, { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro durante a chamada da API de redefinição de senha:",
        error
      );
      throw error;
    }
  },

  atualizarTokenLogin: async (senhaLogin, token) => {
    try {
      const response = await HTTPClient.post(
        "/Autenticar/AtualizarTokenLogin", senhaLogin,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      const tokenResponse = response.data;

      Cookies.set("token", JSON.stringify(tokenResponse), {
        expires: 8 / 24,
        path: "/",
        sameSite: "Lax",
        domain: process.env.REACT_APP_DOMINIO,
        secure: false,
      });

      window.location.href = process.env.REACT_APP_SITE_PORTAL; // Recarrega a página e impede o redirecionamento errado

    } catch (error) {
      console.error(
        "Erro durante a chamada da API de atualizar token pelo login:",
        error
      );
      throw error;
    }
  },

  atualizarTokenLoginUsuario: async (senhaLogin, token) => {
    try {
      const response = await HTTPClient.post(
        "/Autenticar/AtualizarTokenLogin", senhaLogin,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      const tokenResponse = response.data;

      Cookies.set("token", JSON.stringify(tokenResponse), {
        expires: 8 / 24,
        path: "/",
        sameSite: "Lax",
        domain: process.env.REACT_APP_DOMINIO,
        secure: false,
      });

      window.location.href = `${process.env.REACT_APP_SITE_ADMIN}?alert=logado_sucesso`;// Recarrega a página e impede o redirecionamento errado

    } catch (error) {
      console.error(
        "Erro durante a chamada da API de atualizar token pelo login:",
        error
      );
      throw error;
    }
  },


  atualizarInformacoesUsuarioPrimeiroLogin: async (
    usuarioAtualizarPrimeiroLogin,
    pessoaAtualizarPrimeiroLogin,
    enderecoAtualizarPrimeiroLogin,
    telefoneAtualizarPrimeiroLogin,
    token
  ) => {
    try {
      const response = await HTTPClient.put(
        "/Pessoa/AtualizarInformacoesPessoaUsuarioPrimeiroLogin",
        {
          usuarioAtualizarPrimeiroLogin,
          pessoaAtualizarPrimeiroLogin,
          enderecoAtualizarPrimeiroLogin,
          telefoneAtualizarPrimeiroLogin,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return true;
    } catch (error) {
      console.error(
        "Erro durante a chamada da API de atualização de informações do primeiro login:",
        error
      );
      throw error;
    }
  },
};

export default UsuarioApi;
